import { render, staticRenderFns } from "./EditAlarmConfig.vue?vue&type=template&id=7980b31f&scoped=true&"
import script from "./EditAlarmConfig.vue?vue&type=script&lang=js&"
export * from "./EditAlarmConfig.vue?vue&type=script&lang=js&"
import style0 from "./EditAlarmConfig.vue?vue&type=style&index=0&id=7980b31f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7980b31f",
  null
  
)

component.options.__file = "EditAlarmConfig.vue"
export default component.exports